<template>
  <el-dialog
    :title="dialogTitle"
    append-to-body
    :visible="dialogVisible"
    :close-on-click-modal="false"
    center
    width="80%"
    @close="closeDialog"
  >
    <el-row :gutter="12">
      <el-col :span="6">
        <el-card shadow="never">
          <div slot="header" style="text-align: center">
            <span>选择空间</span>
          </div>
          <el-tree
            ref="tree"
            :data="treeData"
            node-key="id"
            show-checkbox
            highlight-current
            :default-checked-keys="defaultKey"
            @check="currentCheck"
            :expand-on-click-node="false"
          >
            <span class="custom-tree-node" slot-scope="{ data }">
              <span>{{ data.name }}</span>
            </span>
          </el-tree>
        </el-card>
      </el-col>
      <el-col :span="18">
        <el-card shadow="never">
          <div slot="header" style="text-align: center">
            <span>设置规则</span>
          </div>
          <SiruiSearch
            ref="baseInfoFormRef"
            :query="baseFormData"
            :columns="formColumn"
            :rules="formRules"
            :isQueryPanel="false"
          ></SiruiSearch>
          <el-form
            label-position="right"
            :rules="baseRules"
            label-width="120px"
            :validate-on-rule-change="false"
            :model="baseInfo"
          >
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="佣金规则">
                  <CommissionRule
                    ref="commissionRuleRef"
                    :departmentList="departmentList"
                    :detailCommissionRuleList="detailCommissionRuleList"
                    :editId="editId"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="备注">
                  <el-input v-model="baseInfo.remark" maxlength="50"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="save(0)">保存</el-button>
      <el-button type="primary" @click="save(1)">提交审核</el-button>
    </span></el-dialog
  >
</template>

<script>
  import API from '@/api/intermodality/commission';
  // import BaseAPI from '@/api/dataBase';
  import CommissionRule from './commissionRule.vue';
  import loading from '@/common/js/load.js';
  export default {
    name: 'commissionDialog',
    props: ['dialogVisible', 'dialogTitle', 'editId'],
    components: { CommissionRule },
    data() {
      return {
        treeData: [],
        defaultKey: [],
        ids: [],
        departmentList: [],
        // roleList: [],
        baseFormData: {
          ruleName: '',
          validDateFrom: '',
          validDateUntil: '',
        },
        baseInfo: {
          remark: '',
        },
        formRules: {
          ruleName: [{ required: true, message: '请输入规则名称', trigger: ['blur', 'change'] }],
          validDateFrom: [
            { required: true, message: '请选择开始日期', trigger: ['blur', 'change'] },
          ],
          validDateUntil: [
            { required: true, message: '请选择结束日期', trigger: ['blur', 'change'] },
          ],
        },
        baseRules: {
          commissionRule: [
            { required: true, message: '请填写佣金规则', trigger: ['blur', 'change'] },
          ],
        },
        selectedTreeData: [],
        detailCommissionRuleList: [],
      };
    },
    computed: {
      formColumn() {
        return [
          {
            prop: 'ruleName',
            name: '规则名称',
            type: 'input',
            span: 8,
            maxlength: 20,
          },
          {
            prop: 'validDateFrom',
            name: '规则有效开始日期',
            type: 'startDaterangePicker',
            format: 'yyyy-MM-DD',
            span: 8,
          },
          {
            prop: 'validDateUntil',
            name: '规则有效截止日期',
            type: 'endDaterangePicker',
            format: 'yyyy-MM-DD',
            span: 8,
          },
        ];
      },
    },
    created() {
      this.getSpace();
      // 获取部门
      this.getDepartmentList();
      // 获取角色
      // this.getRoleList();
      if (this.editId) {
        // 详情
        this.getDetailData();
      }
    },
    methods: {
      getDetailData() {
        this.$axios.get(API.COMMISSION_DETAIL + '/' + this.editId).then((res) => {
          if (res.data.code === 0) {
            const detailData = res.data.data || {};
            if (detailData.commissionRuleSpaces.length > 0) {
              detailData.commissionRuleSpaces.forEach((commission) => {
                this.defaultKey.push(commission.spaceId);
                this.selectedTreeData.push({
                  spaceId: commission.spaceId,
                  spaceName: commission.spaceName,
                });
              });
            }
            this.baseInfo.remark = detailData.remark || '';
            const obj = {
              ruleName: detailData.ruleName,
              validDateFrom: detailData.validDateFrom,
              validDateUntil: detailData.validDateUntil,
            };
            Object.assign(this.baseFormData, obj);
            if (detailData.commissionRuleLines.length > 0) {
              detailData.commissionRuleLines.forEach((item) => {
                this.detailCommissionRuleList.push({
                  ruleDepartmentNo: item.ruleDepartmentNo,
                  ruleDepartmentName: item.ruleDepartmentName,
                  roleNo: item.roleNo,
                  roleName: item.roleName,
                  percentage: item.percentage,
                  monthNumber: item.monthNumber ? item.monthNumber + '' : '',
                  ruleCompanyName: item.ruleCompanyName,
                  ruleCompanyNo: item.ruleCompanyNo,
                  roleList: this.getRoleList(item),
                });
              });
              this.dealData(this.detailCommissionRuleList);
              // console.log(this.detailCommissionRuleList, 'this.detailCommissionRuleList');
              // this.$refs.commissionRuleRef.commissionRuleList = this.detailCommissionRuleList;
            }
          }
        });
      },
      async dealData(list) {
        for (let item of list) {
          if (item.ruleDepartmentNo) {
            await this.getRoleList(item);
          }
        }
        console.log(list, 'list');
        this.$refs.commissionRuleRef.commissionRuleList = list;
      },
      async getRoleList(item) {
        let roleList = [];
        await this.$axios
          .get(`${API.ROLE_BY_DEPARTMENTCODE}/${item.ruleDepartmentNo}`)
          .then((res) => {
            if (res.data.code === 0) {
              item.roleList = res.data.data || [];
            } else {
              roleList = [];
            }
          });
        return roleList;
      },
      closeDialog() {
        this.$emit('close');
        this.defaultKey = [];
      },
      save(val) {
        const list = this.$refs.commissionRuleRef.commissionRuleList || [];
        let flag = false;
        if (list.length > 0) {
          flag = this.mapData(list);
        }
        if (flag) {
          return this.$message({
            showClose: true,
            message: '同一部门同一种角色只能维护一次',
            type: 'warning',
          });
        }
        if (val === 0) {
          // 保存
          if (this.editId) {
            // 编辑
            const params = {};
            Object.assign(params, this.baseFormData);
            params.remark = this.baseInfo.remark;
            params.ruleCompanyNo = this.userInfo.companyCode;
            params.ruleCompanyName = this.userInfo.companyName;

            if (this.selectedTreeData.length > 0) {
              params.commissionRuleSpaces = this.selectedTreeData.filter(
                (item) => item.leafFlag === 0
              );
            } else {
              params.commissionRuleSpaces = [];
            }
            if (params.commissionRuleSpaces.length === 0) {
              return this.$message({
                showClose: true,
                message: '你选择的资产中不全是空间，请确认。',
                type: 'warning',
              });
            }
            params.commissionRuleLines = this.$refs.commissionRuleRef.commissionRuleList || [];
            params.id = this.editId;
            loading.startLoading();
            this.$axios.post(API.COMMISSION_UPDATE, params).then((res) => {
              loading.endLoading();
              if (res.data.code === 0) {
                this.$message({
                  showClose: true,
                  message: '操作成功',
                  type: 'success',
                });
                this.$emit('close', 'refresh');
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              }
            });
          } else {
            // 新增
            const params = {};
            Object.assign(params, this.baseFormData);
            params.remark = this.baseInfo.remark;
            params.ruleCompanyNo = this.userInfo.companyCode;
            params.ruleCompanyName = this.userInfo.companyName;
            if (this.selectedTreeData.length > 0) {
              params.commissionRuleSpaces = this.selectedTreeData.filter(
                (item) => item.leafFlag === 0
              );
            } else {
              params.commissionRuleSpaces = [];
            }
            console.log(params.commissionRuleSpaces, 'params.commissionRuleSpaces');
            if (params.commissionRuleSpaces.length === 0) {
              return this.$message({
                showClose: true,
                message: '你选择的资产中不全是空间，请确认。',
                type: 'warning',
              });
            }
            const commissionRuleLines = this.$refs.commissionRuleRef.commissionRuleList || [];
            params.commissionRuleLines = commissionRuleLines.map((commission) => {
              return {
                ...commission,
                ruleCompanyNo: this.userInfo.companyCode,
                ruleCompanyName: this.userInfo.companyName,
              };
            });
            loading.startLoading();
            this.$axios.post(API.COMMISSION_SAVE, params).then((res) => {
              loading.endLoading();
              if (res.data.code === 0) {
                this.$message({
                  showClose: true,
                  message: '操作成功',
                  type: 'success',
                });
                this.$emit('close', 'refresh');
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              }
            });
          }
        } else {
          // 审批提交
          this.$refs.baseInfoFormRef.validate((valid) => {
            if (valid) {
              if (this.editId) {
                loading.startLoading();
                this.$axios
                  .post(API.APPROVAL_SUBMIT + '/' + this.editId + '/submit')
                  .then((res) => {
                    loading.endLoading();
                    console.log(res, '23333');
                    if (res.data.code === 0) {
                      this.$message({
                        showClose: true,
                        message: '操作成功',
                        type: 'success',
                      });
                      this.$emit('close', 'refresh');
                      console.log('关闭弹窗 刷新页面');
                    }
                  });
              } else {
                const params = {};
                Object.assign(params, this.baseFormData);
                params.remark = this.baseInfo.remark;
                params.ruleCompanyNo = this.userInfo.companyCode;
                params.ruleCompanyName = this.userInfo.companyName;
                if (this.selectedTreeData.length > 0) {
                  params.commissionRuleSpaces = this.selectedTreeData.filter(
                    (item) => item.leafFlag === 0
                  );
                } else {
                  params.commissionRuleSpaces = [];
                }
                if (params.commissionRuleSpaces.length === 0) {
                  return this.$message({
                    showClose: true,
                    message: '你选择的资产中不全是空间，请确认。',
                    type: 'warning',
                  });
                }
                const commissionRuleLines = this.$refs.commissionRuleRef.commissionRuleList || [];
                params.commissionRuleLines = commissionRuleLines.map((commission) => {
                  return {
                    ...commission,
                    ruleCompanyNo: this.userInfo.companyCode,
                    ruleCompanyName: this.userInfo.companyName,
                  };
                });
                loading.startLoading();
                this.$axios.post(API.COMMISSION_SAVE, params).then((res) => {
                  loading.endLoading();
                  if (res.data.code === 0) {
                    console.log(res, '22222');
                    const id = res.data.data.id;
                    this.$axios.post(API.APPROVAL_SUBMIT + '/' + id + '/submit').then((res) => {
                      console.log(res, '23333');
                      if (res.data.code === 0) {
                        this.$message({
                          showClose: true,
                          message: '操作成功',
                          type: 'success',
                        });
                        this.$emit('close', 'refresh');
                        console.log('关闭弹窗 刷新页面');
                      } else {
                        this.$message({
                          showClose: true,
                          message: res.data.msg,
                          type: 'error',
                        });
                      }
                    });
                  } else {
                    this.$message({
                      showClose: true,
                      message: res.data.msg,
                      type: 'error',
                    });
                  }
                });
              }
            }
          });
        }
      },
      mapData(list) {
        let beforeData = list;
        let tempArr = [];
        let afterArr = [];
        for (let i = 0; i < beforeData.length; i++) {
          if (tempArr.indexOf(beforeData[i].ruleDepartmentNo) === -1) {
            afterArr.push({
              ruleDepartmentNo: beforeData[i].ruleDepartmentNo,
              items: [beforeData[i].roleNo],
            });
            tempArr.push(beforeData[i].ruleDepartmentNo);
          } else {
            for (let j = 0; j < afterArr.length; j++) {
              if (afterArr[j].ruleDepartmentNo === beforeData[i].ruleDepartmentNo) {
                afterArr[j].items.push(beforeData[i].roleNo);
                break;
              }
            }
          }
        }
        console.log(afterArr, '22222');
        let flag = false;
        afterArr.map((arr) => {
          if (arr.items.length > 0) {
            if (Array.from(new Set(arr.items)).length < arr.items.length) {
              flag = true;
            }
          }
        });
        return flag;
      },
      getSpace() {
        console.log('获取片区');
        this.$axios
          .post(API.AREA_TREE, { spaceCompanyNo: this.userInfo.companyCode, effectiveStatus: '02' })
          .then((res) => {
            if (res.data.code == 0) {
              this.treeData = res.data.data;
            }
          });
      },
      getDepartmentList() {
        // const params = {
        //   // id: this.userInfo.userCode,
        //   // userCode: this.userInfo.userCode,
        //   personCompanyCode: this.userInfo.companyCode,
        //   // personName: this.userInfo.userName,
        // };
        // console.log(params, 'params');
        // this.$axios.post(BaseAPI.GET_PERSON_API, params).then((res) => {
        //   console.log(res, '1111111111');
        //   if (res.data.code === 0) {
        //     this.departmentList = res.data.data.personDepartmentInfo || [];
        //   }
        // });
        this.$axios.post(API.LIST_DEPARTMENT_API + '/' + this.userInfo.companyCode).then((res) => {
          console.log(res, '1111111111');
          if (0 == res.data.code) {
            this.departmentList = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // getRoleList() {
      //   this.$axios.post(API.ROLE_LIST).then((res) => {
      //     console.log(res, '22222');
      //     if (res.data.code === 0) {
      //       this.roleList = res.data.data || [];
      //     }
      //   });
      // },
      currentCheck(data, checkData) {
        console.log(checkData, '111111');
        this.ids = checkData.checkedNodes;
        const arr = [];
        if (checkData.checkedNodes.length > 0) {
          checkData.checkedNodes.forEach((checked) => {
            arr.push({
              spaceId: checked.id,
              spaceName: checked.name,
              leafFlag: checked.leafFlag,
            });
          });
        }
        this.selectedTreeData = arr;
      },
    },
  };
</script>
